import { afterEvent, defineGameCard } from '../authoring/index.js';
export const RiveterCard = defineGameCard({
    id: 'riveter',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 2 } },
    presentation: {
        name: 'Клепальщик',
        description: 'Когда проходит любая ваша Сборка, созданный робот получает +2/+2, а Клепальщик — +1/+1.',
        glyph: {
            colors: ['#10213A', '#AE3014', '#DA6616', '#74342B', '#4A5055'],
            rows: [
                '.......111111.......',
                '......12333321......',
                '......12233321......',
                '.....144422241......',
                '......1515151.......',
                '......1555551.......',
                '.......155551.......',
                '...11...1551...1....',
                '..1551211111121511..',
                '.155512155555215551.',
                '.155552411111215551.',
                '.15551222111113111..',
                '..11.1224121111511..',
                '.155.1442214141151..',
                '.115133331513222151.',
                '.155133331511111551.',
                '.51112222111221111..',
                '..11114444111111551.',
                '.....14441144211551.',
                '....144444422211551.',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterEvent({
            event: 'AssemblyCompleted',
            when(ctx, event) {
                const self = ctx.self;
                return self?.cellId !== undefined && event.ownerId === self.controllerId;
            },
            run(ctx, event) {
                const self = ctx.self;
                if (self === undefined)
                    return;
                ctx.ops.modifyStat(event.robotInstanceId, 'attack', 2);
                ctx.ops.modifyStat(event.robotInstanceId, 'maxHealth', 2);
                ctx.ops.modifyStat(event.robotInstanceId, 'health', 2);
                ctx.ops.modifyStat(self.id, 'attack', 1);
                ctx.ops.modifyStat(self.id, 'maxHealth', 1);
                ctx.ops.modifyStat(self.id, 'health', 1);
            },
        }),
    ],
    ui: {
        mechanics: ['assembly'],
    },
});
//# sourceMappingURL=riveter.js.map